import React from "react"
import { FormikProps } from "formik"
import MyTextareaFormField from "@common-components/fields/MyTextareaFormField"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM } from "@common-constants/*"

interface Props {
     helpers: FormikProps<any>
     validationSchema: any
     index: number
     namePrefix?: string
}

export const NdfGroupedCommentSection = ({ helpers, validationSchema, index, namePrefix = "childs" }: Props) => {
     const isKm = helpers.values[namePrefix][index].categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM

     return (
          <MyTextareaFormField
               formikProps={helpers}
               validationSchema={validationSchema}
               name={`${namePrefix}[${index}].description`}
               label={isKm ? "Commentaire" : <span className={"required"}>Commentaire</span>}
               placeholder={"Commentaire..."}
               minRows={4}
               classNameLabel={"col-lg-4"}
               classNameField={"col-lg-8"}
          />
     )
}
